import { render } from "./BnuView.vue?vue&type=template&id=70065412&scoped=true"
import script from "./BnuView.vue?vue&type=script&lang=js"
export * from "./BnuView.vue?vue&type=script&lang=js"

import "./BnuView.vue?vue&type=style&index=0&id=70065412&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Documents\\Евадент\\eva\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70065412"]])

export default __exports__